/**
 * Client-reported: "In both App & Admin, all notification - new order,
 * reminder, extension, etc as we discuss notification with bell ring should
 * happen." The Admin panel previously had no audio at all — the sidebar
 * "bell" was purely a visual icon (mdi-bell-*). This plays the same alert
 * tone the mobile apps use (Customer/Photographer's notification_alert.wav)
 * so a new order or a new unresolved alert makes a sound here too, not just
 * a badge count changing silently in a tab that might not be focused.
 */
let cachedAudio: HTMLAudioElement | null = null;

function getAudio(): HTMLAudioElement {
    if (!cachedAudio) {
        cachedAudio = new Audio('/sounds/notification_alert.wav');
    }
    return cachedAudio;
}

/** Best-effort — browsers block autoplay before the user has interacted with
 * the page at all, so a failed play() here is expected/harmless on a
 * freshly-loaded tab, not a real error. */
export function playAlertSound(): void {
    try {
        const audio = getAudio();
        audio.currentTime = 0;
        audio.play()?.catch(() => {});
    } catch {
        // ignore
    }
}
